class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

setHeaderCartIconAccessibility() {
  const cartLink = document.querySelector('#cart-icon-bubble');
  if (!cartLink) return;

  cartLink.setAttribute('role', 'button');
  cartLink.setAttribute('aria-haspopup', 'dialog');

  // Remove old listeners by cloning the element
  const newCartLink = cartLink.cloneNode(true);
  cartLink.parentNode.replaceChild(newCartLink, cartLink);

  newCartLink.addEventListener('click', (event) => {
    event.preventDefault();
    if (this.classList.contains('active')) {
      this.close();
    } else {
      this.open(newCartLink);
    }
  });

  newCartLink.addEventListener('keydown', (event) => {
    if (event.code.toUpperCase() === 'SPACE') {
      event.preventDefault();
      this.open(newCartLink);
    }
  });
}



  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer-open');
    const productImages = document.querySelectorAll('#leftSideMenu, img.logo, .product_image img, .product-wrapper, .product__info-container, .header__inline-menu, .logo, .related-products, .grid, #MainContent, .related-products__heading, .card__information, .motion-reduce, #desktopFooter, h2.news-letter-header, div.footer_message, .card__badge, div.collection__title, .banner__media_desktop img, .layout-1-subheading, .layout-2-subheading, img.block-image, a.layout-1-button, img.small-feature-image, .field, span.layout-2-text-inner, .layout-3-block-image, .soldout-line line, .thumbnail, img.bridal_image, .rich-text__heading, .collection-page-layout-2-subheading, .about-text, .look-wrapper, img.collection-image, img.block-image-layout2-large, .news-banner, .banner-text, .feature-image, .pagination__item, .collection-feature-panel__video, .feature-image, img.layout-4-block-image, .layout-4, div.email-signup-banner-homepage');
    console.log(productImages)
    productImages.forEach(image => {
      image.classList.add("cart-open")
    });

    rightMenu.style.setProperty("filter", "invert(0)");

  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('cart-drawer-open');
    const productImages = document.querySelectorAll('#leftSideMenu, img.logo, .product_image img, .product-wrapper, .product__info-container, .header__inline-menu, .logo, .related-products, .grid, #MainContent, .related-products__heading, .card__information, .motion-reduce, #desktopFooter, h2.news-letter-header, div.footer_message, .card__badge, div.collection__title, .banner__media_desktop img, .layout-1-subheading, .layout-2-subheading, img.block-image, a.layout-1-button, img.small-feature-image, .field, span.layout-2-text-inner, .layout-3-block-image, .soldout-line line, .thumbnail, img.bridal_image, .rich-text__heading, .collection-page-layout-2-subheading, .about-text, .look-wrapper, img.collection-image, img.block-image-layout2-large, .news-banner, .banner-text, .feature-image, .pagination__item, .collection-feature-panel__video, .feature-image, img.layout-4-block-image, .layout-4, div.email-signup-banner-homepage');
    productImages.forEach(image => {
      image.classList.remove("cart-open");
    });

    updateRightMenu();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

renderContents(parsedState) {
  this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
  this.productId = parsedState.id;
  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) return;
    sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  });

  setTimeout(() => {
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.open();
    this.setHeaderCartIconAccessibility(); // ← is this here?
  });
}

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
